import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-gamepad-line text-lg text-background-50"></i>
            </span>
            <span
              className={`text-lg font-heading font-bold transition-colors ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              工口游戏攻略
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <NavLink to="/" scrolled={scrolled} isHome={isHome}>
              首页
            </NavLink>
            <NavLink to="/category/rpg" scrolled={scrolled} isHome={isHome}>
              RPG
            </NavLink>
            <NavLink to="/category/avg" scrolled={scrolled} isHome={isHome}>
              AVG
            </NavLink>
            <NavLink to="/category/slg" scrolled={scrolled} isHome={isHome}>
              SLG
            </NavLink>
            <NavLink to="/category/act" scrolled={scrolled} isHome={isHome}>
              ACT
            </NavLink>
            <NavLink to="/about" scrolled={scrolled} isHome={isHome}>
              关于我们
            </NavLink>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`ri-${
                mobileOpen ? 'close' : 'menu'
              }-line text-xl ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 flex flex-col gap-1">
            <MobileNavLink to="/">首页</MobileNavLink>
            <MobileNavLink to="/category/rpg">角色扮演 RPG</MobileNavLink>
            <MobileNavLink to="/category/avg">文字冒险 AVG</MobileNavLink>
            <MobileNavLink to="/category/slg">策略模拟 SLG</MobileNavLink>
            <MobileNavLink to="/category/act">动作战斗 ACT</MobileNavLink>
            <MobileNavLink to="/category/puzzle">益智解谜 Puzzle</MobileNavLink>
            <MobileNavLink to="/category/sandbox">沙盒自由 Sandbox</MobileNavLink>
            <MobileNavLink to="/category/simulation">生活模拟 Simulation</MobileNavLink>
            <MobileNavLink to="/category/doujin">同人佳作 Doujin</MobileNavLink>
            <MobileNavLink to="/about">关于我们</MobileNavLink>
          </div>
        )}
      </div>
    </nav>
  );
}

function NavLink({
  to,
  children,
  scrolled,
  isHome,
}: {
  to: string;
  children: string;
  scrolled: boolean;
  isHome: boolean;
}) {
  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
        scrolled || !isHome
          ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
          : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
      }`}
    >
      {children}
    </Link>
  );
}

function MobileNavLink({ to, children }: { to: string; children: string }) {
  return (
    <Link
      to={to}
      className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-md cursor-pointer transition-colors"
    >
      {children}
    </Link>
  );
}